module.exports = __webpack_public_path__ + "static/media/erm-logo.ddab820d.svg";